import React, { useEffect, useState } from "react";

import {
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
  useRecoilState,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
} from "recoil";
import { mobileUserState } from "src/store/global/userMobileState";
import { preloaderState } from "src/store/global/preloaderState";
import { showBannerState } from "src/store/global/bannerShowState";
import { headerShowState } from "src/store/global/headerShowState";
import { applyBaseStylesAppRouterState } from "src/store/global/generalState";
import { userState } from "../store/user/userState";
import {
  filterSearchSelectedState,
  hoursAvailableState,
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
} from "../SearchHours/state/atoms";
import useSEO from "src/Hooks/useSEO";
import TabSearchCentral from "../SearchHours/TabSearchCentral.jsx";
import ResultSearchCentral from "src/ResultSearchCentral/Index";
import OptionsUserGuest from "../layout/OptionsUserGuest";
import OptionsUserRegistered from "../layout/OptionsUserRegistered";
//import { activeTabState } from "src/SearchHours/state/atoms";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
//import { Grid } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Logo from "../layout/Logo";
import theme from "src/theme/index";
import { grey, common } from "@mui/material/colors";
import { FilterList } from "@mui/icons-material";
import CalendarHorizontal from "src/SearchHours/components/calendars/CalendarHorizontal";
import { showCalendarHorizontalState } from "src/SearchHours/components/calendars/state/atoms";
import ButtonSearch from "./components/ButtonSearch";
import ButtonClear from "./components/ButtonClear";

const drawerWidth = 350;

function Index(props) {
  const { window } = props;
  //const [mobileOpen, setMobileOpen] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const setPreloader = useSetRecoilState(preloaderState);
  const setShowHeader = useSetRecoilState(headerShowState);
  const setShowBanner = useSetRecoilState(showBannerState);
  //const setUserMobile = useSetRecoilState(mobileUserState);
  const [mobileOpen, setMobileOpen] = useRecoilState(mobileUserState);
  const showCalendarHorizontal = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(showCalendarHorizontalState)
  const setApplyBaseStylesAppRouter = useSetRecoilState(
    applyBaseStylesAppRouterState
  );
  const user = useRecoilValue(userState);
  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  //const setActiveTabSearch = useSetRecoilState(activeTabState);
  //const [activeTabSearch, setActiveTabSearch] = useRecoilState(activeTabState);

  useSEO({title: `Reserva de Hora ${filterSearchSelected.clinicaSelected.value}`});

  useEffect(() => {
    setPreloader(true);
    //resetFilterSearchSelected();

    setShowHeader(false);
    setShowBanner(false);
    setApplyBaseStylesAppRouter(false);

    return () => {
      setShowHeader(true);
      setShowBanner(true);
    };
  }, []);

  const drawer = (
    <div>
      <Toolbar />
      <Box
        sx={{
          overflow: "auto",
          paddingTop: "16px",
          paddingLeft: "5px",
          paddingRight: "5px",
        }}
      >
        <Grid
          style={{
            color: theme.palette.primary.main, //"#4B5563",
            fontWeight: 600,
            fontFamily: "Montserrat",
            fontSize: "20px",
            lineHeight: "18px",
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <FilterList></FilterList> Filtros de búsqueda
        </Grid>

        <TabSearchCentral buttonSearch={<ButtonSearch/>} buttonClear={<ButtonClear/>} />
      </Box>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: { sm: "flex" } }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          // width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
        }}
        style={{ borderRadius: 0 }}
      >
        <Container>
          <Toolbar disableGutters sx={{display: "flex", justifyContent:"space-between"}}>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ mr: 2, display: "flex", height: "68px" }}
            >
              <Logo />
            </Typography>

            <Box sx={{display: "flex", gap: "5px"}}>
              {!user.isAuthenticated && <OptionsUserGuest />}
              {user.isAuthenticated && <OptionsUserRegistered />}
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { md: "none" } }}
              >
                <FilterList></FilterList>
              </IconButton>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {showCalendarHorizontal ? (<CalendarHorizontal />) : null}

      <Box
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          paddingTop: {xs: 20, md: 3},
        }}
      >
        <Toolbar />
        <ResultSearchCentral />
      </Box>
    </Box>
  );
}

Index.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default Index;
